export default "__VITE_ASSET__rA2xm6vA__"